/**
 * @generated SignedSource<<7a83d5e88b7a86722b1ab751a1ba3534>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedInteriorsPhotoRelatedSearchLinks_interiorPhotos$data = {
  readonly relatedPhotoSearchLinks: ReadonlyArray<{
    readonly path: string | null;
    readonly text: string | null;
  }> | null;
  readonly " $fragmentType": "SbSharedInteriorsPhotoRelatedSearchLinks_interiorPhotos";
};
export type SbSharedInteriorsPhotoRelatedSearchLinks_interiorPhotos$key = {
  readonly " $data"?: SbSharedInteriorsPhotoRelatedSearchLinks_interiorPhotos$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedInteriorsPhotoRelatedSearchLinks_interiorPhotos">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedInteriorsPhotoRelatedSearchLinks_interiorPhotos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "relatedPhotoSearchLinks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SearchBrowseInteriorPhotosModule",
  "abstractKey": null
};

(node as any).hash = "72bf5dd3578ff0268444b51198e9c5e1";

export default node;
